"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionWizard = SubscriptionWizard;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _FormattedMessage = require("../components/FormattedMessage");
var _contexts = require("../contexts");
var _useTranslations = require("../hooks/useTranslations");
var _logger = require("../logger");
var _pages = require("./pages");
var _jsxRuntime = require("react/jsx-runtime");
const ContentWrap = (0, _mui.styled)('div')(({
  theme
}) => ({
  minWidth: 200,
  padding: '3px',
  [theme.breakpoints.up('md')]: {
    width: 400
  }
}));
function SubscriptionWizard() {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  const {
    handleCloseFeedback,
    isFeedbackOpen,
    open,
    onClose
  } = (0, _react.useContext)(_contexts.wizardContext);
  const {
    isBackEnabled,
    stepBack,
    currentStep
  } = (0, _react.useContext)(_contexts.stateContext);
  const CurrentPage = (0, _react.useMemo)(() => _pages.Pages[currentStep], [currentStep]);
  const heading = (0, _react.useMemo)(() => formatMessage('newSubscription'), [formatMessage]);
  (0, _logger.logDebug)('SubscriptionWizard currentStep: ', currentStep);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Dialog, {
      ...getTestIdProps(`subscription-wizard`),
      disableEnforceFocus: true,
      header: heading,
      showBackButton: isBackEnabled,
      open: open,
      onBack: stepBack,
      onClose: onClose,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ContentWrap, {
        children: typeof CurrentPage === 'function' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(CurrentPage, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {})
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FeedbackNotification, {
      open: isFeedbackOpen,
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Subscription, {}),
      onClose: handleCloseFeedback,
      ...getTestIdProps('subscription-wizard-feedback'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "subscribed"
      })
    })]
  });
}
